const STORAGE_PROJECT = "jobapp-admin::";

export const KEY_SESSION =  STORAGE_PROJECT + "session";
export const KEY_USER =  STORAGE_PROJECT + "user";
